/*
 * @Description: Description
 * @Author: hexin
 * @Date: 2025-08-05 14:05:01
 * @LastEditTime: 2025-08-05 14:05:01
 */
import en from 'element-ui/lib/locale/lang/en'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "AI-rapporttolkning",
        train: "Träningsöversikt",
        loading: "Laddar, vänligen vänta...",
        loadingError1: "Det gick inte att ladda rapporten",
        loadingError2: "Ursäkta olägenheten. Vänligen försök igen senare.",
    },
    // 登录页面
    login: {
        loginAndRegister: 'Registrera/Logga in',
        registerAndLogin: 'Logga in/Registrera',
        userLogin: 'Logga in',
        title: 'Mobil- och e-postkonton är oberoende av varandra. Vänligen kontrollera din kontotyp.',
        mobileLogin: 'Mobil',
        emailLogin: 'E-post',
        email: 'E-post',
        loginBtn: 'Logga in',
        autoLogin: 'Logga in automatiskt nästa gång',
        retransmission: '{item} sekunder kvar',
        formList: [
            {
                label: 'Vänligen ange ditt mobilnummer',
                placeholder: 'Hämta verifieringskod',
            },
            {
                label: 'Verifieringskod',
                placeholder: '',
            },
            {
                label: 'Ange din e-post',
            },
        ],
        btn: {
            submit: 'Skapa nytt konto',
            title: 'Korrekt information är mycket viktig. Vänligen fyll i den noggrant.',
        },
        rule: {
            phone: {
                requiredMsg: 'Ogiltigt format för mobilnummer',
                patternMsg: 'Mobilnumret är inte registrerat. Vänligen skapa ett nytt konto.',
            },
            authCode: {
                requiredMsg: 'Felaktig verifieringskod. Vänligen försök igen.',
            },
            email: {
                requiredMsg: 'Ogiltigt e-postformat',
                patternMsg: 'E-postadressen är inte registrerad. Vänligen skapa ett nytt konto.',
            },
        },
        codeSuccess: 'Verifieringskod har skickats. Vänligen kontrollera.',
        success: 'Skickat framgångsrikt',
        error: 'Skickning misslyckades',
        loginSuccess: 'Inloggning lyckades',
        account: {
            accountTitle: 'Logga in',
            registerTitle: 'Registrera',
            resetTitle: 'Ställ in lösenord',
            password: 'Lösenord',
            placeholder: 'Vänligen ange ditt lösenord',
            codeLogin: 'Logga in med verifieringskod',
            accountLogin: 'Logga in med lösenord',
            forgotPassword: 'Glömt lösenord?',
            registerTips:[
                'Har du inget konto?', 
                'Registrera', 
                'Kontot finns redan',
                'Registrera dig nu',
            ],
            checkRule: [
                '8-20 tecken',
                'Minst en stor bokstav',
                'Minst en liten bokstav',
                'Minst en siffra', 
                'Lösenorden matchar inte'
            ],
            errorTips: [
                'Felaktigt lösenord', 
                'Inloggningen misslyckades', 
                'A fiók Kontot finns inte létezik'
            ],
            reset:[
                'Återställ lösenord', 
                "Nästa",
                'Nytt lösenord kan inte vara samma som det gamla', 
                'Hoppa över',
                'Lösenordet har ställts in'
            ],
            setPasswordTips:'Lösenordet måste vara 8–20 tecken långt och innehålla versaler, gemener och siffror.',
            confirmPassword: "Bekräfta lösenord",
        },
        switchButton: 'Inloggning med lösenord',
        switchButton1: 'Logga in med verifieringskod',
        loginTips: 'Oregistrerade konton registreras automatiskt vid lyckad inloggning.',
        otherLogin: 'Andra inloggningsalternativ',
        newEmailLogin: 'E-postinloggning',
        newPhoneLogin: 'Mobilnummerinloggning',
        bindLineTips:'Eller',
        bindEmail: 'Logga in med kopplad e-postadress',
        bindPhone: 'Logga in med kopplat mobilnummer',
        bindAndContinue: "Bind och fortsätt",
        bind: "Bind",
        bindEmailTitle: 'Bind e-post',
        bindEmailTips1: "Ingen {item} e-postinfo hittades",
        bindEmailTips2: "Bind e-post för att fortsätta",
        bindEmailTips3: "Ingen e-post bunden. Bind för att logga in och återställa lösenord.",
        boundTitle: 'Har du registrerat dig tidigare?',
        boundCenterTitle1:'Om du är en ny användare',
        boundCenterTips1:'Skapa ett konto för att börja',
        boundCenterTitle2:'Om du redan har ett konto',
        boundCenterTips2:'Bind för att synka historik',
        boundCenterTips3:'Vänligen koppla ett registrerat konto',
        boundCenterTips4:'Rekommenderas',
        boundCenterTips5:'Bind {item} till befintligt konto',
        boundCenterTips6:'Data och rapporter synkas automatiskt',
        boundButton1: 'Skapa konto med {item}',
        boundButton2: 'Bind befintligt konto',
        phoneCode:"Logga in med SMS",
        phonePassword:"Logga in med mobilnummer och lösenord",
        emailCode:"Logga in med e-postkod",
        emailPassword:"Logga in med e-postadress och lösenord",
        accountDoesNotExist:"Detta konto är inte registrerat än. Slutför registreringen med en e-postverifieringskod eller via {item}.",
        toRegister:"Registrera dig",
        bindNow: "Länka nu",
        bindError:[
            'Kopplingen misslyckades',
            'Kopplingen har upphävts',
            'Upphävning av kopplingen misslyckades',
            'Auktoriseringen misslyckades',
            'Auktoriseringen misslyckades, kunde inte hämta kontoinformation.',
            'Kopplingen lyckades',
            'Kontot finns inte. Vänligen koppla ett registrerat konto.',
            'Kopplingen misslyckades. Detta konto är redan kopplat till ett {item}-konto [{nickname}].',
            'Auktoriserad och registrerad som ett konto, frånkoppling stöds inte',
            'Kontot finns inte, använd verifieringskoden för att logga in och registrera dig',
        ],
        accountSecurity: {
            faceBook:'Facebook-konto',
            google: 'Google-konto',
            isBind: 'Inte kopplat',
            dialogTitle: 'Är du säker på att du vill häva kopplingen?',
            dialogCenter: 'Efter att ha hävt kopplingen av {item} kan du inte längre använda det för att logga in på detta konto.',
            bindFailure:'Kopplingen misslyckades',
            bindFailureTips: 'Ditt {item}-konto är redan kopplat till kontot nedan. För att byta koppling till ditt nuvarande konto, vänligen logga in på kontot nedan och häv kopplingen först.',
            returnButton:'Bekräfta och återgå'
        },
        bindEmailError: [
            "E-posten finns redan."
        ],
    },
    // 注册页面
    register: {
        mobileRegister: 'Registrera med mobil',
        emailRegister: 'Registrera med e-post',
        enroll: 'Mobilnumret är redan registrerat.',
        enrollEmail: 'Denna e-postadress är redan registrerad.',
        search: 'Sök',
        title: 'Mobil- och e-postkonton är oberoende av varandra. Vänligen kontrollera din kontotyp.',
        needRead: {
            agree: 'Jag har läst och godkänner',
            privacy: 'Användarnas integritetspolicy',
        },
        register: 'Registrera',
        check: 'Kryssa i "Användarnas integritetspolicy"',
        newUser: 'Ny användarregistrering',
        form: {
            labelList: ['Namn', '* Kön', '* Längd', '* Ålder'],
        },
        placeholder: ['Vänligen ange ditt namn', 'Vänligen ange din längd', 'Vänligen ange din ålder'],
        unit: ['Metriskt', 'Brittiskt', 'år'],
        sexOptions: {
            male: 'Man',
            female: 'Kvinna',
        },
        btn: 'Skicka',
        rules: {
            metricheight: ['Tillåtet längdintervall är 2ft3in–6ft7in. Vänligen ange igen.'],
            heightMsg: ['Tillåtet längdintervall är 70–200 cm. Vänligen ange igen.'],
            ageMsg: ['Tillåtet åldersintervall är 10–99 år. Vänligen ange igen.'],
            agePointMsg: ['Ogiltig inmatning: åldern måste vara ett heltal. Vänligen ange en giltig ålder.'],
        },
        success: 'Registreringen lyckades.',
        userMessage: 'Vänligen ange ditt användarnamn',
        verify: 'Vänligen ange den 4-siffriga verifieringskoden',
        errorMsg: 'Längdformatet måste vara ett heltal. Vänligen ange igen.',
        abnormalMsg: 'Regisztrációs hiba',
    },
    // 模型合成
    model: {
        loading: 'Modellen genereras, vänligen vänta',
        modelLoading: 'Modellen laddas...',
        tabPane: [
            {
                title: 'Djupseendeteknik',
                msg: 'Fånga noggrant lokala kroppsdetaljer genom 3D-skanning för att säkerställa millimeterprecision vid omkretsmätning, vilket gör kroppsförändringar efter träning tydligt synliga.',
            },
            {
                title: 'BDA-algoritm för Kroppssammansättning',
                msg: 'Visbody använder det avancerade BDA-systemet för att bestämma kroppssammansättning, och erbjuder volymbaserad bedömning för att bättre utvärdera hälsorisker från fetma.',
            },
            {
                title: 'Potentiella felkällor',
                msg: 'Lösa kläder eller främmande föremål kan orsaka fel. För mest exakta resultat, bär åtsittande kläder eller minska ytterkläderna.',
            },
            {
                title: 'Ingång till rapport',
                msg: 'Vi rekommenderar att du bokmärker sidan för senare åtkomst. Du kan också skicka denna rapport till din e-post.',
            },
        ],
        collect: ['Vänligen bokmärk denna sida.', 'För att enkelt komma åt rapporten senare.'],
        know: 'Jag förstår',
        reminder: [
            'Vänlig påminnelse',
            'Din 3D-modell har genererats. Prova att svepa för att rotera.',
            'Din rapport är klar. Klicka på "Visa rapport" för att se den.',
            'Hållningsbedömningen misslyckades. Vänligen se rapporten om kroppssammansättning.',
            'Kroppssammansättningen misslyckades. Vänligen se hållningsbedömningsrapporten.',
            'Mätningen misslyckades. Vänligen försök igen på enheten.',
            'Kroppssammansättningen misslyckades. Vänligen försök igen på enheten. sikertelen. Kroppssammansättningen misslyckades. Vänligen försök igen på enheten., próbálja újra az eszközön.',
            'Hållningsbedömningen misslyckades. Vänligen försök igen på enheten.',
        ],
        btn: {
            viewReport: 'Visa rapport',
            bodyReport: 'Visa rapport om kroppssammansättning',
            postureReport: 'Visa hållningsrapport',
            lastReport: 'Visa föregående rapport',
            loading: 'Laddar...',
        },
    },
    // 报告
    report: {
        btn: {
            download: 'Ladda ner rapport',
            send: 'Skicka rapport',
            report: 'Rapport',
        },
        reportSuccess: 'Rapporten har genererats',
        tabPane: {
            labelList: ['Mätningstid', 'Objekt', 'Kroppssammansättning', 'Hållningsbedömning', 'Axelfunktion'],
        },
        sendEmail: 'Skicka till e-post:',
        requiredMsg: 'Vänligen ange din e-postadress',
        patternMsg: 'Vänligen ange en giltig e-postadress',
        send: 'Skicka',
        download: 'Ladda ner rapport',
        sendReport: 'Skicka rapport',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: 'Kön har uppdaterats',
            height: 'Längden har uppdaterats',
            age: 'Åldern har uppdaterats',
        },
        logOut: 'Logga ut',
        personal: 'Profilcenter',
        cut: 'Byt enheter/språk',
        changeSort: 'Byt produktrapport',
        setPassword: 'Ställ in/ändra lösenord',
        describe: '* Efter byte av produktmodell kommer alla relaterade rapporter att visas.',
        describeBtn: 'Efter byte av produktmodell kommer du att omdirigeras till den senaste rapporten.',
        descReport: 'Produktrapporten har bytts',
        unit: ['Metriskt (kg, cm)', 'Brittiskt (ft, in, lb)'],
        read: {
            reading: 'Läs',
            privacy: 'Användarnas integritetspolicy',
        },
        setting: 'Inställningar',
        form: {
            labelList: ['Mobilnummer', 'Enheter', 'Språk', 'Smeknamn', 'Kön', 'Längd', 'Ålder'],
        },
        placeholder: ['Redigera smeknamn', 'Redigera kön', 'Redigera längd', 'Redigera ålder'],
        btn: {
            cancelBtn: 'Avbryt',
            accomplishBtn: 'Klar',
            confirmBtn: 'Bekräfta',
        },
        dialog: [
            'Kön är en viktig faktor i kroppssammansättningsanalys. Att ändra det kan påverka jämförelsen med tidigare data. Bekräfta ändring?',
            'Längd är en viktig faktor i kroppssammansättningsanalys. Att ändra det kan påverka jämförelsen med tidigare data. Bekräfta ändring?',
            'Ålder är en viktig faktor i kroppssammansättningsanalys. Att ändra det kan påverka jämförelsen med tidigare data. Bekräfta ändring?',
        ],
        rules: {
            metricheight: ['Vänligen ange en längd inom intervallet (2ft3in–6ft7in)'],
            heightMsg: ['Vänligen ange en längd inom intervallet (70–200cm)'],
            ageMsg: ['Vänligen ange en ålder inom intervallet (10–99 år)'],
        },
        heightMsg: 'Vänligen välj längd igen',
        ageMsg: 'Vänligen välj ålder igen',
        ModelBinding: 'Någon skannade koden före dig. Vänligen mät om.',
        ReportEmpty: {
            title: 'Du har inga relaterade rapporter än',
            desc: 'Hitta Visbody 3D-skannern och gör en mätning!',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: 'Någon skannade koden före dig. Vänligen mät om.',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: 'Du har inga relaterade rapporter än',
        desc: 'Hitta Visbody 3D-skannern och gör en mätning!',
        descS30: 'Hitta Visbody-S30 3D-skannern och gör en mätning!',
        descM30: 'Hitta Visbody-M30 3D-skannern och gör en mätning!',
    },
    // 用户信息
    userInfo: {
        height: 'Längd:',
        age: 'Ålder:',
        unit: 'éves',
        weight: 'Vikt',
    },
    // 体成分
    mass: {
        title: 'Översikt Kroppssammansättning',
        titles: 'Kroppssammansättning',
        springFrame: '',
        massFrame: 'Inga mätdata för idag',
        contrast: 'Välj en rapport att jämföra med',
        contrastReport: 'Välj en jämförelserapport',
        noRecord: 'Ingen post',
        score: 'poäng',
        status: 'Din nuvarande kroppssammansättningsstatus',
        WT: 'Vikt',
        PBF: 'Kroppsfettprocent',
        endSymbol: '。',
        // 测量相关
        measure: {
            value: 'Värden',
            standardRange: 'Standardintervall',
            comparedWithLastLime: 'Förändring',
            comparedNet: 'Förändring',
            current: 'Nuvarande mätningspoäng',
            WT: 'Vikt',
            FFM: 'Mager kroppsmassa',
            BFM: 'Kroppsfettmassa',
            LM: 'Muskelmassa',
            TBW: 'Teljes testvíz',
            SM: 'Skelettmuskulatur',
            PROTEIN: 'Protein',
            TM: 'Oorganiska salter',
            BMR: 'Basalmetabolism',
            WHR: 'Midja-höft-kvot',
            BMI: 'BMI',
            PBF: 'Kroppsfettprocent',
            VFG: 'Visceralt fettnivå',
            unit: 'kg',
            BMRUnit: 'kcal/dag',
        },
        // 定义解读
        explain: [
            {
                title: 'Vikt',
                msg: 'Vikt är summan av kroppsvatten, protein, oorganiska salter och kroppsfett.',
            },
            {
                title: 'Mager kroppsmassa',
                msg: 'Mager kroppsmassa är den totala kroppsvikten utan fett.',
            },
            {
                title: 'Kroppsfettmassa',
                msg: 'Kroppsfett är summan av subkutant, visceralt och intermuskulärt fett.',
            },
            {
                title: 'Muskelmassa',
                msg: 'Muskelmassa avser kroppens magra vävnader och inkluderar skelettmuskulatur, glatt muskulatur och hjärtmuskulatur.',
            },
            {
                title: 'Total kroppsvätska',
                msg: 'Kroppsvätska utgör 50-70% av kroppsvikten. Det finns främst i celler och vätskor, mestadels i muskelceller.   ',
            },
            {
                title: 'Skelettmuskulatur',
                msg: 'Skelettmuskel, även kallad tvärstrimmig muskel, är fäst vid skelettet. Detta visar dess kvantitet.',
            },
            {
                title: 'Protein',
                msg: 'Protein är en kvävehaltig fast substans som finns i alla celler och är en nyckelkomponent i muskelmassan.',
            },
            {
                title: 'Oorganiska salter',
                msg: 'Oorganiska ämnen i kroppen kallas oorganiska salter och de utgör cirka 5 % av kroppsvikten.',
            },
            {
                title: 'Basalmetabolism',
                msg: 'BMR är den totala energin som kroppen förbrukar på en dag i vaket och vilande tillstånd, opåverkad av rörelse, mat eller temperatur.',
            },
            {
                title: 'Midja-höft-kvot',
                msg: 'Midja-höft-kvot (WHR) är en viktig indikator för att utvärdera central fetma.',
            },
            {
                title: 'BMI',
                msg: 'BMI används för att bedöma fetma och är en vanlig internationell standard.',
            },
            {
                title: 'Kroppsfettprocent',
                msg: 'Kroppsfettprocent avser andelen fett i den totala kroppsvikten.',
            },
            {
                title: 'Visceralt fettnivå',
                msg: 'Visceralt fettnivå är en viktig indikator för att bedöma dold fetma.',
            },
            {
                title: 'Intracellulär vätska (ICW)',
                msg: 'Intracellulär vätska är vätskan inuti cellerna och en kärnkomponent i protoplasma.',
            },
            {
                title: 'Extracellulär vätska (ECW)',
                msg: 'Extracellulär vätska är vätskan utanför cellerna, inklusive plasma och interstitialvätska.',
            },
            {
                title: 'Metabolisk ålder',
                msg: 'Metabolisk ålder avser prestandan hos kroppen och dess hälsorelaterade metaboliska funktioner.',
            },
            {
                title: 'ECW/TBW-kvot',
                msg: 'ECW/TBW-kvoten är andelen extracellulärt vatten (ECW) av kroppens totala vattenmängd (TBW). Det är ett viktigt mått för att bedöma kroppens vätskebalans.',
            },
        ],
        // 节段
        segment: {
            fat: 'Segmentellt fett',
            muscle: 'Segmentell muskulatur',
            right: 'Höger',
            left: 'Vänster',
            standard: 'Normal',
            lowStandard: 'Under',
            superStandard: 'Över',
            peel: '(Tara)',
        },
    },
    // 体态
    shape: {
        title: 'Översikt Hållningsbedömning',
        titles: 'Hållning',
        status: 'Din nuvarande hållningsstatus',
        suggest: 'Rekommendation',
        possibility: ', visar',
        models: {
            front: 'Framifrån',
            left: 'Vänster profil',
            right: 'Höger profil',
            top: 'Baksida',
            low: 'Under genomsnittet',
            high: 'Över genomsnittet',
            normal: 'Normal',
        },
        item: {
            deviate: 'Värden',
            result: 'Beskrivning',
            normal: 'Normal',
            abnormal: 'Onormal',
            keAbnormal: 'Möjlig avvikelse',
            head: 'Framskjutet huvud',
            headSlant: 'Huvudlutning',
            roundShoulderLeft: 'Framåtroterade axlar (vänster sida)',
            roundShoulderRight: 'Framåtroterade axlar (höger sida)',
            highLowShoudler: 'Ojämna axlar',
            pelvis: 'Bäcken framåt/bakåt förskjutning',
            leftKneeCheck: 'Vänster knäutvärdering',
            rightKneeCheck: 'Höger knäutvärdering',
            leg: 'Bentypsbedömning',
            leftLeg: 'Vänster ben:',
            rightLeg: 'Höger ben:',
        },
        // 定义解读
        explain: [
            {
                title: 'Framskjutet huvud',
                msg: 'Vinkeln mellan linjen från öronpunkten till nackens mitt på vänster sida och den laterala mittlinjen',
            },
            {
                title: 'Huvudlutning',
                msg: 'Vinkeln mellan linjen från huvudets mittpunkt till nackens mitt och den främre mittlinjen',
            },
            {
                title: 'Framåtroterade axlar (vänster sida)',
                msg: 'Vinkeln mellan den högsta punkten på vänster rygg och axelns tangentlinje',
            },
            {
                title: 'Framåtroterade axlar (höger sida)',
                msg: 'Vinkeln mellan den högsta punkten på höger rygg och axelns tangentlinje',
            },
            {
                title: 'Ojämna axlar',
                msg: 'Vertikalt avstånd mellan vänster och höger akromion på ryggen',
            },
            {
                title: 'Bäcken framåt/bakåt förskjutning',
                msg: 'Vinkeln mellan nacke-, höft- och fotledspunkter i vänster sidovy',
            },
            {
                title: 'Vänster knäutvärdering',
                msg: 'Vinkeln mellan höft, knä och fotled i vänster sidovy',
            },
            {
                title: 'Höger knäutvärdering',
                msg: 'Vinkeln mellan höft, knä och fotled i höger sidovy',
            },
            {
                title: 'Bentypsbedömning',
                msg: 'Vinkeln som bildas av höft, knä och fotled i framifrån för båda benen',
            },
        ],
        exception: [
            {
                title: 'Förskjuten åt vänster',
                abnormal: '',
            },
            {
                title: 'Förskjuten åt höger',
                abnormal: '',
            },
            {
                title: 'Vänster högre',
                abnormal: '',
            },
            {
                title: 'Höger högre',
                abnormal: '',
            },
            {
                title: 'Bakåtlutning av bäckenet',
                abnormal: '',
            },
            {
                title: 'Framåtförskjutning av bäckenet',
                abnormal: '',
            },
            {
                title: 'Vänster knäöversträckning',
                abnormal: '',
            },
            {
                title: 'Vänster knäflexion',
                abnormal: '',
            },
            {
                title: 'Höger knäöversträckning',
                abnormal: '',
            },
            {
                title: 'Höger knäflexion',
                abnormal: '',
            },
            {
                title: 'K-benstyp',
                abnormal: '',
            },
            {
                title: 'D-benstyp',
                abnormal: '',
            },
            {
                title: 'X-benstyp',
                abnormal: '',
            },
            {
                title: 'O-benstyp',
                abnormal: '',
            },
            {
                title: 'Främre Bäcken-Tilt',
                abnormal: ''
            },
            {
                title: 'Bakre Bäcken-Tilt',
                abnormal: ''
            },
            {
                title: 'Onormal vänster benlängd',
                abnormal: ''
            },
            {
                title: 'Kóros jobb lábhossz',
                abnormal: ''
            }
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'Vertikalt avstånd mellan örat och kroppens tyngdpunktlinje',
            },
            {
                msg: 'Vinkel mellan linjen som förbinder öronen och den horisontella linjen',
            },
            {
                msg: 'Vertikalt avstånd mellan vänster akromion och tyngdpunktlinjen',
            },
            {
                msg: 'Vertikalt avstånd mellan höger akromion och tyngdpunktlinjen',
            },
            {
                msg: 'Skillnad mellan nackbas och akromionlinje (vänster & höger)',
            },
            {
                msg: 'Vertikalt avstånd mellan höftled och kroppens tyngdpunktlinje',
            },
            {
                msg: 'Vinkel mellan fotled, 1 cm under vänster knä och höft (sagittalplan)',
            },
            {
                msg: 'Vinkel mellan fotled, 1 cm under höger knä och höft (sagittalplan)',
            },
            {
                msg: 'Vinkel mellan vänster/höger höfter, knän och fotleder (koronalplan)',
            },
        ],
        item: {
            pelvis: 'Framåtförskjutning av bäckenet',
        },
    },
    // 围度信息
    girth: {
        title: 'Kroppsomkrets',
        present: '(denna gång)',
        noHistory: 'Ingen data',
        tpl: [
            {
                title: 'Nackomkrets',
                key: 'neckGirth',
            },
            {
                title: 'Vänster överarmsomkrets',
                key: 'leftUpperArmGirth',
            },
            {
                title: 'Höger överarmsomkrets',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'Bröstomfång',
                key: 'bustGirth',
            },
            {
                title: 'Hög midjeomfång',
                key: 'waistGirth',
            },
            {
                title: 'Mellersta midjeomfång',
                key: 'midWaistGirth',
            },
            {
                title: 'Höftomfång',
                key: 'hipGirth',
            },
            {
                title: 'Vänster lår omkrets',
                key: 'leftThighGirth',
            },
            {
                title: 'Vänster lårs mittomkrets',
                key: 'leftMidThighGirth',
            },
            {
                title: 'Vänster lårs minsta omkrets',
                key: 'leftMinThighGirth',
            },
            {
                title: 'Höger lår omkrets',
                key: 'rightThighGirth',
            },
            {
                title: 'Höger lårs mittomkrets',
                key: 'rightMidThighGirth',
            },
            {
                title: 'Höger lårs minsta omkrets',
                key: 'rightMinThighGirth',
            },
            {
                title: 'Vänster vadomkrets',
                key: 'leftCalfGirth',
            },
            {
                title: 'Höger vadomkrets',
                key: 'rightCalfGirth',
            },
            {
                title: 'Låg midja',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: 'Axelfunktion',
        model: {
            val: 'Värden',
            scope: 'Maximal aktivitetsplats',
            diff: 'Förändring',
        },
        normal: 'Inga uppenbara avvikelser hittades vid bedömningen',
        normalAll: 'Inga uppenbara avvikelser hittades i axelfunktionen',
        conclusion: 'Slutsats',
        analyse: 'Analys: ',
        suggest: 'Rekommendation: ',
        cause: 'Vänligen konsultera en professionell för ytterligare utvärdering.',
    },
    reportTips: {
        title: "Vill du verkligen ta bort den här rapporten? Den kan inte återställas efter att den har tagits bort.",
        confirm: "Radera",
        success: "Rapporten har tagits bort",
        partial: "Rapporten har tagits bort, men synkroniseringen av vissa data misslyckades. Kontakta administratören.",
        failed: "Radering misslyckades, försök igen senare.",
        btnMsg: 'OK',
        alaryTips: 'Denna rapport har tagits bort av administratören. Omdirigerar till nästa rapport.',
    },
    saveQr: {
        title: 'Visbody 3D-kroppsrapport',
        btnMsg: 'Långtryck på bilden för att spara till telefonen',
        tips: 'Om det inte går att spara, vänligen aktivera behörigheter i [Inställningar]',
    },
    share: {
        title: 'Vänligen kopiera länken nedan för att dela',
        btnMsg: 'Kopiera',
    },
    'bodyPrediction': {
        'body-title': '体型预测',
        'body-yu-ce-status': '根据您当前状态预测',
        'body-setting': '体型预测设置',
        'body-li-xiang': '理想值：',
        'body-ti-zhong': 'Vikt',
        'body-ti-zhi-lv': 'Kroppsfettprocent',
        'body-ji-rou': '肌肉含量',
        'yu-che-pre': '预测前',
        'yu-che-after': '预测后',
        'zan-model-no': '暂无模型',
        'ti-xing-error': '体型预测结果合成失败~',
        'ti-xing-worker-error': '小编猜测可能是网络原因导致的~',
        'ti-xing-adjust': '调节量',
        'ji-rou-title': 'Muskelmassa',
        'ti-zi-fang': 'Kroppsfettmassa',
        'dang-pre-zhi': '当前值：',
        'nen-zhang': 'Visceralt fettnivå',
        'nen-zhang-title': '内脏脂肪面积说明',
        'nen-zhang-title1': '内脏脂肪分布在内脏器官之间得脂肪，易导致腹部肥胖，内脏脂肪面积显示的是内脏脂肪横截面积。'
    },
     ...en,
    ...agrEn,
    wifi: {
        'title': 'WiFi配置',
        'tips': '请输入以下 WiFi 网络的密码',
        'password':'WIFI 密码',
        'password-placeholder': '请输入 WiFi 密码',
        'password-tips': '密码区分大小写，请确保输入正确',
        'button': '生成二维码',
        'h5-title': '配置WIFI信息',
        'wifi-name': 'WIFI名称:',
        'wifi-password': 'WIFI密码:',
        'wifi-qr-tips1': '* 请确认 WiFi 名称和密码无误后，对准设备屏幕下方的相机位置进行扫描。',
        'wifi-qr-tips2': '请将 WiFi 二维码对准屏幕下方的相机位置进行扫描。',
        'wifi-qr-button': '返回',
    },
    "waist": {
        "title": "Midje- och bukdimensioner",
        "hou": "Bak",
        "qian": "Fram"
    },
    "yao_wei_1": "Midja",
    "yao_bu_fen_shu": "Midjepoäng",
    "waist_fen": "poäng",
    "yao_wei": "Midjeomfång",
    "yao_wei_jian_ti_ji": "Volym mellan midjelinjerna",
    "yao_tun_bi": "Midja-höft-kvot",
    "lun_kuo_fen_xi": "Konturanalys",
    "bei_bu": "Ryggregion",
    "tunbu": "Sätesregion",
    "bei_bu_ti_ji": "Ryggvolym",
    "zheng_chang_fan_wei": "Normál tartomány:",
    "shang_ci": "Förra ",
    "ben_ci": "Nu ",
    "gupen": {
        "zheng_chang": "Normalt",
        "qian_qin_yan_chang": "Onormalt främre bäcken-tilt",
        "qian_qin_yi": "Risk för främre bäcken-tilt",
        "hou_qin_yi": "Risk för bakre bäcken-tilt",
        "hou_qin_yan_chang": "Onormalt bakre bäcken-tilt",
        "zuo_chang_yan_chang": "Onormal vänster benlängd",
        "zuo_chang_yi": "Risk för avvikande vänster benlängd",
        "you_chang_yi": "Risk för avvikande höger benlängd",
        "you_chang_yan_chang": "Onormal höger benlängd"
    },
    "gao_yao_xian": "Hög midjeomfång",
    "gao_yao_zhong_xian": "Hög Midja Mittlinje",
    "gao_yao_xia_xian": "Hög Midja Nedre Linje",
    "xiao_yao_shang_xian": "Låg Midja Övre Linje",
    "xiao_yao_zhong_xian": "Låg Midja Mittlinje",
    "xiao_yao_xian": "Låg midja",
    "qv_jian1": "Övre sektion av hög midja",
    "qv_jian2": "Nedre sektion av hög midja",
    "qv_jian_zhong": "Mitten av midjan",
    "qv_jian3": "Övre sektion av låg midja",
    "qv_jian4": "Nedre sektion av låg midja",
    "celiang.failed": "Mätningen Misslyckades. Vänligen Bär Åtsittande Kläder Och Stå Stilla Under Mätningen.",
    "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Huvudlutning med lätt avvikelse i halsryggen. Tänk på sitthållningen.",
    "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Huvudlutning och avvikelse i halsryggen. Hållningskontroll och träning rekommenderas.",
    "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Kraftig huvudlutning och avvikelse i halsryggen. Professionell bedömning rekommenderas.",
    "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Lätt avvikelse i bröstryggen. Förbättra hållningskontrollen.",
    "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Avvikelse i bröstryggen påverkar stabiliteten. Riktad träning rekommenderas.",
    "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Tydlig avvikelse i bröstryggen och asymmetri. Professionell korrigering rekommenderas.",
    "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Lätt avvikelse i ländryggen, balanserad hållning. Bålstabilisering rekommenderas.",
    "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Avvikelse i ländryggen påverkar stabiliteten. Korrigerande träning rekommenderas.",
    "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Tydlig avvikelse i ländryggen. Professionell förbättringsplan rekommenderas.",
    "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Hypertoni: levator scapulae, SCM, övre trapezius. Svaghet: djupa nackflexorer. Stabilisering och avslappning rekommenderas.",
    "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hypertoni: vänster SCM och scalenus posterior. Svaghet: höger SCM. Bilateral balans och avslappning rekommenderas.",
    "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hypertoni: höger SCM. Svaghet: vänster SCM och scalenus posterior. Symmetrisk stabilisering och avslappning rekommenderas.",
    "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hypertoni: vänster övre trapezius. Svaghet: mellersta/nedre trapezius. Träning (mitten/nedre) och avslappning rekommenderas.",
    "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Hypertoni: inåtrotatorer och adduktorer. Svaghet: gluteus medius. Gluteusträning och stretching rekommenderas.",
    "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Hypertoni: gluteus medius och piriformis. Svaghet: adduktorer, inåtrotatorer, LCL. Benstabilisering och sätesavslappning rekommenderas.",
    "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Hypertoni: gluteus medius och piriformis. Ensidig svaghet: adduktorer, inåtrotatorer, LCL. Bilateral träning rekommenderas.",
    "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hypertoni: vänster hamstrings och popliteus. Svaghet: quadriceps och soleus. Quadriceps-/soleusträning och stretching rekommenderas.",
    "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hypertoni: vänster quadriceps. Svaghet: gluteus maximus och hamstrings. Sätes-/baksidesträning och stretching rekommenderas.",
    "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hypertoni: höger hamstrings och popliteus. Svaghet: quadriceps och soleus. Quadriceps-/soleusträning och stretching rekommenderas.",
    "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hypertoni: höger quadriceps. Svaghet: gluteus maximus och hamstrings. Sätes-/baksidesträning och stretching rekommenderas.",
    "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Lätt ryggradsavvikelse. Tänk på hållningen och träna bålen.",
    "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Måttlig ryggradsavvikelse. Professionellt vägledd träning rekommenderas.",
    "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hypertoni: höger övre trapezius. Svaghet: mellersta/nedre trapezius. Träning (mitten/nedre) och avslappning rekommenderas.",
  "neckReport": {
  "title": "Halsfunktion",
  "conclusion": "Nackfunktionsbedömning",
  "loading": "Rapporten skapas. Vänta.",
  "failed": "Rapportgenerering misslyckades",
  "analysis": "Analys",
  "suggestion": "Rekommendation",
  "suggestionText": "Sök experter för vidare diagnos och behandling"
}
}
